// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Ju9I","item":"PaymentsMobile_item__f9Vkv","label":"PaymentsMobile_label__2srtP","amount":"PaymentsMobile_amount__21-BR"};